import { Injector, NgModule } from '@angular/core';
import { RouteService } from '../../routing/services/route.service';
import { RoutingModule as RouterModule } from '../../routing/routing.module';

@NgModule({
    imports: [
        RouterModule,
    ],
    exports: [
        RouterModule,
    ]
})
export abstract class RoutingModule {

    constructor(protected injector: Injector, protected routeService: RouteService) {
        if (this[ 'boot' ] && typeof this[ 'boot' ] === 'function') {
            this[ 'boot' ](this.injector);
        }

        if (this[ 'routes' ] && typeof this[ 'routes' ] === 'function') {
            this[ 'routes' ](this.routeService);

            this.routeService.apply();
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/modules/routing-module.ts